import React from 'react'

const Dashboard = () => {
    return (
        <div
            className="min-h-screen flex items-center justify-center bg-blue-900 text-3xl text-white"
        >
            <div>This is Dashboard </div>
        </div>
    )
}

export default Dashboard